import React from 'react'
import styles from './VideoPlayerPreloader.module.scss'

export const VideoPlayerPreloader = () => (
  <div className={styles.VideoPLayerPreloader}>
    <div className={styles.LoaderImage} />
  </div>
)
